import { createSlice } from "@reduxjs/toolkit";
import { getCategory, submitCategory, deleteCategory } from "./Utils/categoryUtils";
import Swal from 'sweetalert2';

const initialState = {
    filters: {
        "filter[id]": "",
        "filter[name]": "",
        "sort": "-id",
        "page": "",
    },
    categories: [],
    pagination: {},
    loading: false,
    error: null,
    currentCategory: {  // Ini buat menyimpan data form yang lagi aktif
        id: null,
        name: "",
        about: "",
        description: "",
        banner: null,
    }
};


const categorySlice = createSlice({
    name: "category",
    initialState,
    reducers: {
        setFormData: (state, action) => {
            state.currentCategory = { ...state.currentCategory, ...action.payload };
        },
        resetFormData: (state) => {
            state.currentCategory = initialState.currentCategory;
        },
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle getCategory
            .addCase(getCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(getCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle submitCategory (update atau tambah branch)
            .addCase(submitCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitCategory.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Kategori Berhasil Disimpan',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });

                // Kalau data baru, tambah ke daftar
                if (!state.categories.find(category => category.id === action.payload.id)) {
                    state.categories.push(action.payload);
                } else {
                    // Kalau update, replace data lama
                    state.categories = state.categories.map(category =>
                        category.id === action.payload.id ? action.payload : category
                    );
                }

                // Reset form setelah simpan
                state.currentCategory = initialState.currentCategory;
            })
            .addCase(submitCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Handle deleteCategory
            .addCase(deleteCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteCategory.fulfilled, (state, action) => {
                state.loading = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Data Berhasil dihapus',
                    toast: true,
                    position: 'center',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                state.categories = state.categories.filter(category => category.id !== action.payload.id);
            })
            .addCase(deleteCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setFormData, resetFormData, setFilters } = categorySlice.actions;
export default categorySlice.reducer;